import { useContext } from "react";
import { PageNewState, ComponentEditDialogContext } from ".";

export const useComponentEditDialogState = () => {
  const { pageState, setPageState } = useContext(ComponentEditDialogContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
